import {
  SET_MOMENTS
} from 'app/actions/types';

import {
  getMoments as getMomentsSvc
} from 'app/services/moments';

export const getMoments = params => async dispatch => {
  let moments = await getMomentsSvc(params);

  if (moments) {
    dispatch({
      type: SET_MOMENTS,
      payload: moments.params
    });
  }

  return moments;
}

export const setMomentParams = params => async dispatch => {
  dispatch({
    type: SET_MOMENTS,
    payload: params
  });

  return Promise.resolve();
}
